import "./App.css";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import {
  MAIN_ROUTE,
  CLUSTERS_ROUTE,
  CLUSTER_ROUTE,
  STORES_ROUTE,
  STORE_ROUTE,
  LOGIN_ROUTE,
  ITEMS_ROUTE,
  ITEM_ROUTE,
  CATEGORIES_ROUTE,
  CATEGORY_ROUTE,
  PROMOS_ROUTE,
  CART_ROUTE,
  COMPLEX_CART_ROUTE,
  PROFILE_ROUTE,
  ORDERS_ROUTE,
  ADDRESSES_ROUTE,
  BONUSES_ROUTE,
  COMPLEX_ORDERS_ROUTE,
  FAVORITES_ROUTE,
  CITY_ROUTE,
  CHECKOUT_ROUTE,
  COMPLEX_CHECKOUT_ROUTE,
} from "./common/utils/constants";
import { Protected } from "./common/components/Protected";
import { Main } from "./pages/main/Main";
import { Cluster } from "./pages/cluster/Cluster";
import { ClusterDetails } from "./pages/cluster/clusterDetails/ClusterDetails";
import { Store } from "./pages/store/Store";
import { StoreDetails } from "./pages/store/storeDetails/StoreDetails";
import { Login } from "./pages/login/Login";
import { NotFound } from "./pages/notFound/NotFound";
import { RootLayout } from "./hoc/RootLayout";

import { Item } from "./pages/item/Item";
import { ItemDetails } from "./pages/item/itemDetails/ItemDetails";
import { Category } from "./pages/category/Category";
import { CategoryDetails } from "./pages/category/categoryDetails/CategoryDetails";
import { Promo } from "./pages/promo/Promo";
import { PromoDetails } from "./pages/promo/promoDetails/PromoDetails";
import { Cart } from "./pages/cart/Cart";
import { ComplexCart } from "./pages/complexCart/ComplexCart";

import { Profile } from "./pages/profile/Profile";
import { Order } from "./pages/profile/order/Order";
import { OrderDetails } from "./pages/profile/order/orderDetails/OrderDetails";
import { Address } from "./pages/profile/address/Address";
import { Bonus } from "./pages/profile/bonus/Bonus";
import { ComplexOrder } from "./pages/profile/complexOrder/ComplexOrder";
import { ComplexOrderDetails } from "./pages/profile/complexOrder/complexOrderDetails/ComplexOrderDetails";
import { Favorite } from "./pages/profile/favorite/Favorite";
import { Checkout } from "./pages/checkout/Checkout";
import { ComplexCheckout } from "./pages/complexCheckout/ComplexCheckout";

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route element={<RootLayout />}>
          <Route path={MAIN_ROUTE} element={<Main />} />
          <Route path={`${CITY_ROUTE}/:id`} element={<Main />} />
          <Route path={CLUSTERS_ROUTE} element={<Cluster />} />
          <Route path={`${CLUSTER_ROUTE}/:id`} element={<ClusterDetails />} />
          <Route path={STORES_ROUTE} element={<Store />} />
          <Route path={`${STORE_ROUTE}/:id`} element={<StoreDetails />} />
          <Route path={ITEMS_ROUTE} element={<Item />} />
          <Route path={`${ITEM_ROUTE}/:id`} element={<ItemDetails />} />
          <Route path={CATEGORIES_ROUTE} element={<Category />} />
          <Route path={`${CATEGORY_ROUTE}/:id`} element={<CategoryDetails />} />
          <Route path={PROMOS_ROUTE} element={<Promo />} />
          <Route path={`${PROMOS_ROUTE}/:id`} element={<PromoDetails />} />
          <Route path={LOGIN_ROUTE} element={<Login />} />
          <Route path={CART_ROUTE} element={<Cart />} />
          <Route path={COMPLEX_CART_ROUTE} element={<ComplexCart />} />
          <Route element={<Protected />}>
            <Route path={PROFILE_ROUTE} element={<Profile />} />
            <Route path={ORDERS_ROUTE} element={<Order />} />
            <Route path={`${ORDERS_ROUTE}/:id`} element={<OrderDetails />} />
            <Route path={ADDRESSES_ROUTE} element={<Address />} />
            <Route path={BONUSES_ROUTE} element={<Bonus />} />
            <Route path={COMPLEX_ORDERS_ROUTE} element={<ComplexOrder />} />
            <Route path={CHECKOUT_ROUTE} element={<Checkout />} />
            <Route
              path={COMPLEX_CHECKOUT_ROUTE}
              element={<ComplexCheckout />}
            />
            <Route
              path={`${COMPLEX_ORDERS_ROUTE}/:id`}
              element={<ComplexOrderDetails />}
            />
            <Route path={FAVORITES_ROUTE} element={<Favorite />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}

export default App;
